import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=d85a7b36&scoped=true"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
import style0 from "./SidebarSharePlugin.vue?vue&type=style&index=0&id=d85a7b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a7b36",
  null
  
)

export default component.exports